/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_meta_adsets: StateInterface["ai_boost_meta_adsets"] = {
	_id: "",
	ad_set_id: "",
	ad_set_name: "",
	campaign_id: "",
	daily_budget: 0,
	billing_event: "",
	optimization_goal: "",
	bid_strategy: "",
	status: "",
	start_time: "",
	end_time: "",
	special_ad_categories: [],
	destination_type: "",
	targeting: {
		geo_locations: {
			custom_locations: [],
		},
		age_min: 0,
		age_max: 0,
		genders: [],
		publisher_platforms: [],
		device_platforms: [],
		locales: [],
		flexible_spec: [],
		targeting_automation: {
			advantage_audience: 0,
		},
	},
	boost_id: "",
	property_id: "",
	is_deleted: false,
	deleted_at: "",
	created_at: "",
	updated_at: "",
	last_optimized_at: "",
	last_optimization_action: "",
	last_optimization_remarks: "",
};
